Handlebars.registerPartial('partials/60004/notification_preferences/reservation_settings/reservation_settings', Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<reservation-settings-na></reservation-settings-na>";
},"useData":true}));